module.exports = __webpack_public_path__ + "img/reset.982f2e13.svg";